import { SensoresImageTypesApi } from '@/domain/entities/Api'
import { Commit } from '@/store/types'
import { getEnvironments } from '@/environments'
import { checkWebp } from '@/components/helpers/checkWebp'
import { client as fetch } from './ClientService'

export interface ImagenesSatelitalesInterface {
  getImagenesSatelitales():Promise<Commit<SensoresImageTypesApi>>
}

export default class ImagenesSatelitalesService implements ImagenesSatelitalesInterface {
  env = getEnvironments()
  apiUrl: string = this.env.url.API ? this.env.url.API : window.location.origin
  hash: string = this.env.settings.PELIGRO.hash || ''
  webp: string = '&webp=0'

  constructor (apiUrl?: string) {
    this.apiUrl = apiUrl || this.apiUrl
  }

  async getImagenesSatelitales (): Promise<Commit<SensoresImageTypesApi>> {
    try {
      const { isWebpSupported } = await checkWebp('lossy')
      this.webp = isWebpSupported && this.env.settings.IMAGENES_SATELITALES.useWebp ? '&webp=1' : '&webp=0'
      const response: SensoresImageTypesApi = await fetch(`${this.apiUrl}/api/pronostico/imagenes/sensores?${this.hash}${this.webp}`)
      return { type: 'IMAGENES_SATELITALES_FETCHED', payload: response }
    } catch (e) {
      return { type: 'IMAGENES_SATELITALES_ERROR', payload: e }
    }
  }
}
